export function sortByName(obj1: { name: string }, obj2: { name: string }) {
  return obj1.name.localeCompare(obj2.name);
}
